import React, {useEffect, useState} from 'react';
import './aboutStartSection.scss';
import { ReactComponent as LeftGrid } from "./components/LeftGridImage1.svg";
import { ReactComponent as LeftGrid1440 } from "./components/LeftGridImage1440.svg";
import { ReactComponent as LeftGridMobile } from "./components/LeftGridImageMobile.svg";
import { ReactComponent as RightGrid } from "./components/RightGridImage1.svg";
import { ReactComponent as RightGrid1440 } from "./components/RightGridImage1440.svg";
import { ReactComponent as RightGridMobile } from "./components/RightGridImageMobile.svg";
import { ReactComponent as StartStar } from "./components/StartStar.svg";
import { ReactComponent as Coin1 } from "./components/Coin1.svg";
import { ReactComponent as Coin2 } from "./components/Coin2.svg";
import { ReactComponent as Coin3 } from "./components/Coin3.svg";
import { ReactComponent as Coin4 } from "./components/Coin4.svg";

const AboutStartSection = () => {
	const [width, setWidth] = useState(window.innerWidth);

	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	return (
		<div className="aboutStart">
			<StartStar className="aboutStart__star big"/>
			<StartStar className="aboutStart__star middle"/>
			<StartStar className="aboutStart__star little"/>
			<Coin1 className="aboutStart__coin c1" />
			<Coin2 className="aboutStart__coin c2" />
			<Coin3 className="aboutStart__coin c3" />
			<Coin4 className="aboutStart__coin c4" />
			<div className="aboutStart__images">
				{
					width < 1920 ?
						width < 425 ? (
							<LeftGridMobile className="aboutStart__images_left" />
						)	: (
							<LeftGrid1440 className="aboutStart__images_left" />
						) : (
							<LeftGrid className="aboutStart__images_left" />
						)
				}
				{
					width < 1920 ?
						width < 425 ? (
							<RightGridMobile className="aboutStart__images_right" />
						) : (
							<RightGrid1440 className="aboutStart__images_right" />
						) : (
							<RightGrid className="aboutStart__images_right" />
						)
				}
			</div>
			<div className="aboutStart__content">
				<h1>Creating Innovations</h1>
				<h1 className="purple">for Your Success</h1>
				<p>We've been building for a long time. We're building for you. We build based on your feedback.</p>
				<div className="aboutStart__content_button">
					<button className="secondButton">
						<span>Become One of Us</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default AboutStartSection;